import {
  IconBellIllustration,
  IconBudgetIllustration,
  IconChecklistIllustration,
  IconHeartsIllustration,
  IconMessageIllustration,
  IconPlannerIllustration,
} from '@bridebook/web/components/svg';
import { getPushNotificationOptInVariant } from '@bridebook/web/lib/ui/selectors';
import { useSelector } from '@bridebook/web/lib/utils';

const PrePromptIcon = () => {
  const pushNotificationOptInVariant = useSelector(getPushNotificationOptInVariant);

  switch (pushNotificationOptInVariant) {
    case 'inbox':
    case 'enquiry':
      return <IconMessageIllustration />;
    case 'tasks':
      return <IconChecklistIllustration />;
    case 'budget':
      return <IconBudgetIllustration />;
    case 'shortlist':
      return <IconHeartsIllustration />;
    case 'articles':
      return <IconPlannerIllustration />;
    default:
      return <IconBellIllustration />;
  }
};

export default PrePromptIcon;
